export enum STATUS {
  READY = "READY",
  LOADING = "LOADING",
  COMPLETE = "COMPLETE",
  ERROR = "ERROR",
}

export interface StateChanger {
  loaded: () => void;
  error: () => void;
  complete: () => void;
  reset: () => void;
  getStatus: () => STATUS;
}

export enum DIRECTION {
  TOP = "top",
  BOTTOM = "down",
}

export interface ScrollEvent {
  distance: number;
  totalScroll: number;
  viewHeight: number;
}
